import { c as _c } from "react/compiler-runtime";
import { Box, Heading, Text, VStack } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
type ContentIntroProps = {
  title: any;
  description?: string;
  padding?: number | string;
};
const ContentIntro = props => {
  const $ = _c(11);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const t0 = props.padding;
  let t1;
  if ($[0] !== getBreakpointValue) {
    t1 = getBreakpointValue(["2xl", "3xl", "4xl"]);
    $[0] = getBreakpointValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.title || $[3] !== t1) {
    t2 = <Heading size={t1} textAlign="center" textStyle="contentIntro">{props.title}</Heading>;
    $[2] = props.title;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props.description) {
    t3 = props.description && <Box maxWidth="container.md"><Text fontSize="xl" textAlign="center">{props.description}</Text></Box>;
    $[5] = props.description;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== props.padding || $[8] !== t2 || $[9] !== t3) {
    t4 = <VStack align="center" gap={4} padding={t0} width="full">{t2}{t3}</VStack>;
    $[7] = props.padding;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default ContentIntro;